import { defineComponent as Y, useAttrs as G, computed as t, ref as J, toRef as K, createElementBlock as y, openBlock as c, mergeProps as A, withDirectives as Q, createCommentVNode as m, renderSlot as X, createElementVNode as Z, toHandlers as _, unref as p, normalizeClass as g, toDisplayString as w, createBlock as I, resolveDynamicComponent as ee, toRaw as te } from "vue";
import { RevButtonIcon as ae } from "@ds/components/ButtonIcon";
import { useNativeInput as le } from "../../composables/useNativeInput.js";
import { vFocus as oe } from "../../directives/focus.js";
import ie from "../../icons/generated/IconCrossInCircle.vue2.js";
import { useI18n as se } from "@ds/plugin";
import ue from "../../translations/generic.translations.js";
import { isEmpty as B } from "../../utils/isEmpty.js";
import { omit as ne } from "../../utils/omit.js";
import { tw as e } from "../../utils/tailwind.js";
import { TYPES_WITH_DEFAULT_PLACEHOLDER as re } from "./InputText.constant.js";
const de = ["disabled", "required", "value"], ce = ["for"], ve = ["id", "role"], Ve = /* @__PURE__ */ Y({
  name: "RevInputText",
  inheritAttrs: !1,
  __name: "InputText",
  props: {
    autofocus: { type: Boolean, default: !1 },
    clearButtonAriaLabel: { default: void 0 },
    description: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    format: { type: Function, default: (l) => l },
    hasClearButton: { type: Boolean, default: !0 },
    helperTextClass: { type: [String, Boolean, Array, Object], default: e`mt-8` },
    icon: { default: void 0 },
    id: {},
    inputClass: { type: [String, Boolean, Array, Object], default: e`` },
    label: {},
    modelValue: {},
    size: { default: "medium" },
    type: { default: "text" },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "invalid", "valid", "clear"],
  setup(l, { expose: z, emit: N }) {
    const a = l, n = N, b = G(), D = t(
      () => ne(b, ["class", "style"])
    ), E = t(() => ({
      class: b.class,
      style: b.style
    })), s = J(null), h = le(s, K(a, "modelValue"), {
      onInput: (i) => {
        const d = a.format(i.target.value);
        s.value && (s.value.value = String(d)), n("update:modelValue", d), n("input", i);
      },
      onValidityChange: (i) => {
        i ? n("valid") : n(
          "invalid",
          s.value?.validity,
          s.value?.validationMessage ?? ""
        );
      }
    }), L = () => {
      n("input", {
        target: {
          value: ""
        }
      }), n("update:modelValue", ""), n("clear"), s.value?.focus();
    }, o = t(() => a.size === "small"), v = t(() => !B(a.error)), x = t(
      () => typeof a.modelValue == "string" ? !B(a.modelValue) : !(typeof a.modelValue > "u")
    ), u = t(
      () => v.value || h.touched.value && h.invalid.value
    ), S = t(
      () => a.type ? re.includes(a.type) : !1
    ), F = t(() => !B(b.placeholder)), q = t(() => !(o.value && x.value)), C = t(
      () => !o.value && (h.focused.value || S.value || x.value || F.value)
    ), r = t(
      () => !o.value && a.hasClearButton && x.value
    ), f = t(
      () => !o.value && !!a.icon && !r.value
    ), V = t(() => o.value ? "" : u.value && v.value ? a.error : a.description), T = t(() => {
      if (u.value)
        return u.value && `${a.id}_error`;
    }), P = t(
      () => ({
        ...D.value,
        id: a.id,
        type: a.type,
        "aria-label": a.label,
        ...u.value ? { "aria-invalid": "true" } : {},
        ...v.value ? { "aria-describedby": T.value } : {}
      })
    ), R = se(), O = a.clearButtonAriaLabel || R(ue.buttonClear);
    z({
      input: s
    });
    const k = t(() => (i) => {
      const d = e`motion-safe:transition-colors motion-safe:duration-200`;
      return o.value ? [
        d,
        e`bg-action-default-mid`,
        i && e`peer-hover:bg-action-default-mid-hover peer-disabled:bg-action-default-mid-disabled`,
        !i && e`hover:bg-action-default-mid-hover disabled:bg-action-default-mid-disabled`
      ] : [
        d,
        e`bg-static-default-low`,
        i && e`peer-hover:bg-static-default-low-hover peer-disabled:bg-transparent`,
        !i && e`hover:bg-static-default-low-hover disabled:bg-static-default-low-disabled`
      ];
    }), H = t(() => [
      e`peer rounded-sm input-normalize relative w-full min-w-0 pl-12`,
      a.inputClass,
      k.value(!1),
      o.value ? [
        e`h-32 border-none disabled:text-onaction-default-mid-disabled`,
        u.value ? e`text-onaction-danger-mid` : e`text-onaction-default-mid`
      ] : [
        e`text-action-default-hi input-normalize h-48 border border-solid disabled:border-action-default-low-disabled disabled:text-action-default-hi-disabled`,
        u.value ? e`border-action-danger-low focus-visible:border-action-danger-low-focus` : e`border-action-default-low focus-visible:border-action-default-low-focus`
      ],
      u.value ? e`focus-visible-outline-danger-low` : e`focus-visible-outline-default-low`,
      C.value && e`pt-14`,
      r.value && e`pr-48 type-date:pr-8`,
      f.value && e`pr-44 type-date:pr-8`,
      !r.value && !f.value && e`pr-12`
    ]), $ = t(() => [
      e`relative`,
      o.value ? e`body-1-bold` : e`body-1`
    ]), j = t(() => [
      e`body-2 flex items-baseline peer-disabled:text-static-default-low-disabled`,
      a.helperTextClass,
      v.value ? e`text-static-danger-hi` : e`text-static-default-low`
    ]), M = t(() => [
      o.value && e`text-onaction-default-mid body-1-bold top-16`,
      o.value && v.value && e`text-onaction-danger-mid`,
      C.value && e`text-static-default-low caption top-5 transform-none`,
      !C.value && !o.value && e`text-action-default-hi body-1 top-24`,
      r.value && e`pr-36`,
      f.value && e`pr-32`,
      e`pointer-events-none absolute left-[calc(0.75rem+1px)] right-12 z-[inherit]`,
      e`max-w-full`,
      e`-translate-y-1/2 truncate peer-disabled:text-onaction-default-mid-disabled`,
      e`motion-safe:transition-all motion-safe:duration-200`
    ]), W = t(() => [
      e`rounded-sm pointer-events-none absolute right-4 top-4 z-[1] size-40`,
      k.value(!0)
    ]), U = t(() => [
      e`pointer-events-none absolute right-10 z-[1] h-40`,
      a.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]);
    return (i, d) => (c(), y("div", A(E.value, { class: $.value }), [
      Q(Z("input", A({
        ref_key: "input",
        ref: s
      }, P.value, {
        class: H.value,
        "data-test": "input-text-input",
        disabled: l.disabled,
        required: l.required,
        value: l.format(l.modelValue)
      }, _(p(h).listeners, !0)), null, 16, de), [
        [p(oe), l.autofocus]
      ]),
      q.value ? (c(), y("label", {
        key: 0,
        class: g(M.value),
        for: l.id
      }, w(l.label) + w(l.required ? " *" : ""), 11, ce)) : m("", !0),
      r.value || f.value ? (c(), y("div", {
        key: 1,
        class: g(W.value)
      }, [
        r.value ? (c(), I(p(ae), {
          key: 0,
          "aria-label": p(O),
          class: "pointer-events-auto absolute disabled:pointer-events-none",
          "data-test": "clear-button",
          disabled: l.disabled,
          icon: p(ie),
          type: "button",
          variant: "secondary",
          onClick: L
        }, null, 8, ["aria-label", "disabled", "icon"])) : m("", !0),
        f.value ? (c(), I(ee(te(l.icon)), {
          key: 1,
          "aria-hidden": "true",
          class: g(U.value),
          "data-test": "icon",
          size: "20"
        }, null, 8, ["class"])) : m("", !0)
      ], 2)) : m("", !0),
      X(i.$slots, "default"),
      V.value ? (c(), y("p", {
        key: 2,
        id: T.value,
        "aria-live": "assertive",
        class: g(j.value),
        role: u.value ? "alert" : void 0
      }, w(V.value), 11, ve)) : m("", !0)
    ], 16));
  }
});
export {
  Ve as default
};
